import React, { useState } from "react";

const CabinetSelector = ({ label, canEdit, value, onChange }) => {
  const [loading, setLoading] = useState(false);
  const cabinets = [
    {
      name: "Cape",
      swatch: "#ddd3c6",
      image: "https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/kitchen-cabinets/GroveCape.png"
    },
    {
      name: "Chateau",
      swatch: "#af8e72",
      image: "https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/kitchen-cabinets/GroveChateau.png"
    },
    {
      name: "Currant",
      swatch: "#8f2d2a",
      image: "https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/kitchen-cabinets/GroveCurrant.png"
    },
    {
      name: "Evergreen",
      swatch: "#3d573c",
      image: "https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/kitchen-cabinets/GroveEvergreen.png"
    },
    {
      name: "Goldleaf",
      swatch: "#f5af36",
      image: "https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/kitchen-cabinets/GroveGoldleaf.png"
    },
    {
      name: "Sandalwood",
      swatch: "#a99275",
      image: "https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/kitchen-cabinets/GroveSandalwood.png"
    },
    {
      name: "Silhouette",
      swatch: "#424046",
      image: "https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/kitchen-cabinets/GroveSilhouette.png"
    },
    {
      name: "Terrain",
      swatch: "#90867e",
      image: "https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/kitchen-cabinets/GrovTerr.png"
    },
    {
      name: "Bayside",
      swatch: "#667c91",
      image: "https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/kitchen-cabinets/GroveBayside.png"
    },
    {
      name: "Biscayne",
      swatch: "#384859",
      image: "https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/kitchen-cabinets/GroveBiscayne.png"
    },
    {
      name: "Juniper",
      swatch: "#4f4b3e",
      image: "https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/kitchen-cabinets/GroveJuniper.png"
    },
    {
      name: "Laurel",
      swatch: "#9d996a",
      image: "https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/kitchen-cabinets/GroveLaurel.png"
    },
    {
      name: "Midnight",
      swatch: "#2c2c2c",
      image: "https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/kitchen-cabinets/GroveMidnight.png"
    },
    {
      name: "Palmetto",
      swatch: "#b6b9b2",
      image: "https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/kitchen-cabinets/GrovePalmetto.png"
    },
    {
      name: "Pewter",
      swatch: "#e3e2e1",
      image: "https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/kitchen-cabinets/grove-pewter.png"
    },
    {
      name: "Seabreeze",
      swatch: "#b1c1bf",
      image: "https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/kitchen-cabinets/GroveSeabreeze.png"
    },
    {
      name: "Seaport",
      swatch: "#4c5d75",
      image: "https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/kitchen-cabinets/GroveSeaport.png"
    },
    {
      name: "Stonybrook",
      swatch: "#49433d",
      image: "https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/kitchen-cabinets/GroveStonybrook.png"
    },
    {
      name: "Opal",
      swatch: "#f3f0e6",
      image: "https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/kitchen-cabinets/GrovOpal.png"
    },
    {
      name: "White",
      swatch: "#ffffff",
      image: "https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/kitchen-cabinets/GrovWhit.png"
    },
  ];

  const selectedCabinet = cabinets.find((c) => c.name === value);

  return (
    <div
      style={{
        display: "flex",
        flexWrap: "wrap",
        alignItems: "flex-start",
        gap: "2rem",
        marginTop: "1rem",
      }}
    >
      {/* LEFT SIDE: Dropdown + swatches */}
      <div style={{ flex: "1 1 280px", minWidth: "250px" }}>
        <h4>{label}</h4>
        <p style={{ fontSize: "0.9rem", color: "#555" }}>
          Choose a cabinet finish below.
        </p>

        <div style={{ marginBottom: "1rem" }}>
          <select
            value={value || ""}
            onChange={(e) => {
              onChange(e.target.value);
              setLoading(true);
            }}
            disabled={!canEdit}
            style={{
              width: "100%",
              padding: "0.6rem",
              borderRadius: "6px",
              border: "1px solid #ccc",
              fontSize: "1rem",
              backgroundColor: "white",
              cursor: canEdit ? "pointer" : "not-allowed",
            }}
          >
            <option value="">-- Select a Cabinet Finish --</option>
            {cabinets.map((cabinet) => (
              <option key={cabinet.name} value={cabinet.name}>
                {cabinet.name}
              </option>
            ))}
          </select>
        </div>

        <div>
          <div
            style={{
              display: "flex",
              flexWrap: "wrap",
              gap: "0.5rem",
            }}
          >
            {cabinets.map((cabinet) => (
              <div
                key={cabinet.name}
                onClick={() => {
                  if (canEdit) {
                    onChange(cabinet.name);
                    setLoading(true);
                  }
                }}
                title={cabinet.name}
                style={{
                  width: "28px",
                  height: "28px",
                  backgroundColor: cabinet.swatch,
                  borderRadius: "4px",
                  cursor: canEdit ? "pointer" : "not-allowed",
                  border:
                    value === cabinet.name
                      ? "2px solid #007bff"
                      : "1px solid #ccc",
                }}
              ></div>
            ))}
          </div>
        </div>
      </div>

      {/* RIGHT SIDE: Big preview image */}
      <div
        style={{
          flex: "1 1 300px",
          minWidth: "250px",
          textAlign: "center",
          position: "relative",
        }}
      >
        {selectedCabinet ? (
          <>
            {loading && (
              <div
                style={{
                  position: "absolute",
                  top: "50%",
                  left: "50%",
                  transform: "translate(-50%, -50%)",
                  zIndex: 2,
                }}
              >
                <div
                  style={{
                    width: "36px",
                    height: "36px",
                    border: "4px solid #ccc",
                    borderTop: "4px solid #007bff",
                    borderRadius: "50%",
                    animation: "spin 1s linear infinite",
                  }}
                ></div>
              </div>
            )}

            <img
              src={selectedCabinet.image}
              alt={selectedCabinet.name}
              onLoad={() => setLoading(false)}
              onError={() => setLoading(false)}
              style={{
                width: "100%",
                maxWidth: "300px",
                borderRadius: "8px",
                border: "1px solid #ddd",
                boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
                opacity: loading ? 0.3 : 1,
                transition: "opacity 0.3s ease",
              }}
            />

            <div
              style={{
                marginTop: "0.5rem",
                fontWeight: "bold",
                color: "#333",
              }}
            >
              {selectedCabinet.name}
            </div>
          </>
        ) : (
          <div
            style={{
              color: "#777",
              fontStyle: "italic",
              marginTop: "2rem",
            }}
          >
            Select a finish to preview
          </div>
        )}
      </div>

      {/* Spinner animation */}
      <style>
        {`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}
      </style>
    </div>
  );
};

export default CabinetSelector;